<script lang="ts" setup>
const { t } = useI18n();

useSeoMeta({
  title: t('meta.title'),
  description: t('meta.description'),
  ogTitle: t('meta.title'),
  ogDescription: t('meta.description'),
});
</script>

<template>
  <main>
    <SectionAboutMission />
    <LazyIdleSectionCompanyWorth hydrate-on-idle class="aboutPage__worthSection" />
    <LazyIdleSectionCompanyDescription hydrate-on-idle class="aboutPage__descriptionSection" />
    <LazyIdleSectionCompanyIdea hydrate-on-idle />
    <LazyIdleSectionProductComponents hydrate-on-idle class="aboutPage__componentsSection" />
    <LazyIdleSectionEmptyBanner hydrate-on-idle class="aboutPage__emptyBanner" />
  </main>
</template>

<i18n>
ru:
  title: О компании
  og_title: Don't Touch My Skin - о компании
  image_alt: Информация о компании
  meta:
    title: Миссия, ценности и философия комфортного ухода за кожей
    description: "Узнайте о миссии Don't Touch My Skin: безопасность, комфорт и здоровье. Мы создаем эффективную косметику с активными ингредиентами, которая не содержит ароматизаторов и красителей."

en:
  title: About
  og_title: Don't Touch My Skin - about
  image_alt: Company information
  meta:
    title: Mission, Values, and Philosophy of Comfortable Skincare
    description: "Learn about the Don't Touch My Skin mission: safety, comfort, and health. We create effective cosmetics with active ingredients that are free of fragrances and dyes."
</i18n>

<style lang="scss">
.aboutPage {
  &__descriptionSection {
    margin-top: 123px;
    margin-bottom: 123px;

    @include mq('sm') {
      margin-top: 20px;
      margin-bottom: 60px;
    }
  }

  &__componentsSection {
    margin-top: 71px;
  }

  &__emptyBanner {
    margin-top: 71px;

    @include mq('sm') {
      margin-top: 4px;
    }
  }

  &__worthSection {
    margin-top: 110px;

    @include mq('sm') {
      margin-top: 4px;
    }
  }
}
</style>
